import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const MobileHeader = ({ title, showBack = false }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
        px: 1,
      }}
    >
      {showBack && (
        <IconButton onClick={() => navigate(-1)} size="small">
          <ArrowBack />
        </IconButton>
      )}
      <Typography variant="h6" fontWeight={500}>
        {title}
      </Typography>
    </Box>
  );
};

export default MobileHeader;
